export const SocialType = {
    FACEBOOK: "facebook",
    TWITTER: "twitter",
    LINKEDIN: "linkedin",
    INSTAGRAM: "instagram",
    WEBSITE: "website"
}